// /apps/patient/src/components/layout/PatientLayout.tsx

import { Outlet } from 'react-router-dom';
import { Sidebar } from '../navigation/Sidebar';
import { BottomTabBar } from '../navigation/BottomTabBar';
import { MobileTopBar } from '../navigation/MobileTopBar';
import { useState, useEffect } from 'react';
import { patientApiService } from '../../services/api';

export function PatientLayout() {
  const [counts, setCounts] = useState({
    unreadMessages: 0,
    upcomingAppointments: 0,
    activePrograms: 0,
    unpaidInvoices: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        // Fetch counts for badges
        const [messages, appointments, programs, invoices] = await Promise.allSettled([
          patientApiService.getUnreadMessageCount(),
          patientApiService.getUpcomingAppointmentCount(),
          patientApiService.getActiveProgramCount(),
          patientApiService.getUnpaidInvoiceCount()  // Add this
        ]);
    
        setCounts({
          unreadMessages: messages.status === 'fulfilled' ? messages.value : 0,
          upcomingAppointments: appointments.status === 'fulfilled' ? appointments.value : 0,
          activePrograms: programs.status === 'fulfilled' ? programs.value : 0,
          unpaidInvoices: invoices.status === 'fulfilled' ? invoices.value : 0  // Add this
        });
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };

    fetchCounts();
    // Poll for updates every 60 seconds
    const interval = setInterval(fetchCounts, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Mobile top navigation */}
      <MobileTopBar />
      
      <div className="min-h-screen bg-gray-50 flex">
        {/* Desktop sidebar */}
        <Sidebar counts={counts} />
        
        {/* Main content area */}
        <div className="flex-1 flex flex-col">
          <main className="flex-1 overflow-y-auto pb-16 lg:pb-0 pt-mobile-top lg:pt-0">
            <Outlet />
          </main>
          
          {/* Mobile bottom navigation */}
          <BottomTabBar counts={counts} />
        </div>
      </div>
    </>
  );
}